module.exports = __webpack_public_path__ + "static/media/tanzania-shipping-map.ec79ef91.jpg";